export default {"src":"/pro/_next/static/media/usdc.3acc98a8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};